import { FC } from "react";
import { Stack } from "@mui/material";
import {
  ResourceExplorerAnomaliesInsightBreakdown,
  ResourceExplorerFilterSchema,
} from "@/services/cloudchipr.api";
import { ExploreWithAIButtonV2AnomaliesTooltipTitleItem } from "@/storybook/explore-with-AI-button/ExploreWithAIButtonV2AnomaliesTooltipTitleItem";

interface ExploreWithAIButtonV2AnomaliesTooltipTitleProps {
  anomalies?: ResourceExplorerAnomaliesInsightBreakdown[];
  onClick(mode: ResourceExplorerFilterSchema["mode"]): void;
}

export const ExploreWithAIButtonV2AnomaliesTooltipTitle: FC<
  ExploreWithAIButtonV2AnomaliesTooltipTitleProps
> = ({ anomalies, onClick }) => {
  return (
    <Stack spacing={1} p={1.5} bgcolor="white">
      {anomalies?.map((item) => {
        if (!item?.type || !item?.total) {
          return null;
        }
        return (
          <ExploreWithAIButtonV2AnomaliesTooltipTitleItem
            {...item}
            onClick={onClick}
            key={item.type}
          />
        );
      })}
    </Stack>
  );
};

const trendsLabels = {
  spikes: "Spikes",
  decreaseTrends: "Decreases",
  decrease_trends: "Decreases",
  increaseTrends: "Increases",
  increase_trends: "Increases",
};
